import { PolicyCheck } from '@/features/auth/authorization';

export const WorkOrderPolicies: Record<string, PolicyCheck> = {
  'equipment.work-orders.view': ({ acl, user, meta }) => {
    return acl.equipment.work_orders.view;
  },
  'equipment.work-orders.create': ({ acl, user, meta }) => {
    return acl.equipment.work_orders.create;
  },
  'equipment.work-orders.update': ({ acl, user, meta }) => {
    return acl.equipment.work_orders.edit;
  },
  'equipment.work-orders.delete': ({ acl, user, meta }) => {
    return acl.equipment.work_orders.delete;
  },
};
